import { mergeAttributes, Node } from "@tiptap/core"
import { ReactNodeViewRenderer } from "@tiptap/react"
import { ImageUploadNodeView } from "src/tiptap/components/tiptap-node/image-upload-node/image-upload-node"
import type {
  UploadedImageAttrs,
  UploadImage,
} from "src/tiptap/components/tiptap-node/image-upload-node/image-upload-kit"

export interface ImageUploadNodeOptions {
  type?: string
  accept?: string
  limit?: number
  maxSize?: number
  uploadImage?: UploadImage
  onError?: (error: Error) => void
  onSuccess?: (result: UploadedImageAttrs) => void
  HTMLAttributes: Record<string, unknown>
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    imageUpload: {
      setImageUploadNode: () => ReturnType
    }
  }
}

export const ImageUploadNode = Node.create<ImageUploadNodeOptions>({
  name: "imageUpload",

  group: "block",

  atom: true,

  selectable: true,

  draggable: true,

  addOptions() {
    return {
      type: "image",
      accept: "image/*",
      limit: 1,
      maxSize: 0,
      uploadImage: undefined,
      onError: undefined,
      onSuccess: undefined,
      HTMLAttributes: {},
    }
  },

  addAttributes() {
    return {
      accept: {
        default: this.options.accept,
      },
      limit: {
        default: this.options.limit,
      },
      maxSize: {
        default: this.options.maxSize,
      },
    }
  },

  parseHTML() {
    return [{ tag: 'div[data-type="image-upload"]' }]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(
        { "data-type": "image-upload" },
        this.options.HTMLAttributes,
        HTMLAttributes
      ),
    ]
  },

  addNodeView() {
    return ReactNodeViewRenderer(ImageUploadNodeView)
  },

  addCommands() {
    return {
      setImageUploadNode:
        () =>
        ({ commands }) =>
          commands.insertContent({ type: this.name }),
    }
  },
})

export default ImageUploadNode
